<ng-container *ngIf="archived">
	<button class="restore-btn" mat-menu-item data-cy="restore-btn" (click)="restore()">{{"common_restore" | translate}}</button>
	<button
		class="delete-btn"
		data-cy="permanently-delete-btn"
		mat-menu-item (click)="deletePermanently()">
		{{"common_permanently-delete" | translate}}
	</button>
</ng-container>
